import { useEffect, useState } from 'react';

// Dark mode manual, persistido em localStorage. Tailwind está em darkMode:'class',
// então alternamos a classe `dark` no <html>.
const STORAGE_KEY = 'sigem-theme';

export const getStoredDark = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'dark';
  } catch {
    return false;
  }
};

export const applyDark = (dark: boolean): void => {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle('dark', dark);
  // Alinha o color-scheme nativo (scrollbars, inputs) ao tema escolhido,
  // evitando scrollbar escura sobre UI clara (e vice-versa).
  document.documentElement.style.colorScheme = dark ? 'dark' : 'light';
  try {
    localStorage.setItem(STORAGE_KEY, dark ? 'dark' : 'light');
  } catch {
    /* ignore */
  }
};

/** [isDark, toggle] — aplica e persiste a escolha. */
export const useDarkMode = (): readonly [boolean, () => void] => {
  const [dark, setDark] = useState<boolean>(getStoredDark);
  useEffect(() => { applyDark(dark); }, [dark]);
  return [dark, () => setDark((d) => !d)] as const;
};
